import { Injectable, Injector, Type } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class InjectorProviderService {

    static injector: Injector;

    constructor(injector: Injector) {
        InjectorProviderService.injector = injector;
    }

    static get<T>(token: Type<T>): T {
        return InjectorProviderService.injector.get(token);
    }
}
